import theme from '@styles/theme/index';
export default {
  heading: (size?: number | null, color?: string | null, uppercase?: boolean, align?: 'left' | 'center' | 'right', pb?: number | string[] | number[], whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces', capitalize?: boolean) => {
    const fontSize = size && `${size}px !important`;
    const textAlign = align && align;
    return {
      fontSize,
      textAlign,
      pb: typeof pb === 'number' ? `${pb}px` : pb,
      color: color || theme.rawColors.darkGrey700,
      whiteSpace,
      '&.headings': {
        fontFamily: theme.fonts.uniformExtra,
        lineHeight: '100%',
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.caps,
        '&.heading__one, &.heading__two': {
          fontSize: theme.fontSizes.h1,
          textTransform: 'uppercase',
          '&.mobile': {
            fontSize: [theme.fontSizes.h2, theme.fontSizes.h2, theme.fontSizes.h2, theme.fontSizes.h2, theme.fontSizes.h1],
            lineHeight: '110%'
          },
          lineHeight: '100%'
        },
        '&.heading__three': {
          fontSize: theme.fontSizes.h2,
          textTransform: 'uppercase',
          '&.mobile': {
            fontSize: [theme.fontSizes.h3, theme.fontSizes.h3, theme.fontSizes.h3, theme.fontSizes.h3, theme.fontSizes.h2]
          },
          lineHeight: '100%'
        },
        '&.heading__four': {
          fontFamily: theme.fonts.uniform,
          fontSize: theme.fontSizes.h3,
          lineHeight: '140%',
          textTransform: uppercase ? 'uppercase' : 'none',
          '&.bold': {
            fontFamily: theme.fonts.uniformMedium,
            fontWeight: theme.fontWeights.medium,
            lineHeight: '100%'
          },
          '&.mobile': {
            fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3]
          }
        },
        '&.heading__five': {
          fontFamily: theme.fonts.uniform,
          fontSize: theme.fontSizes.h4,
          lineHeight: '140%',
          textTransform: 'none',
          '&.bold': {
            fontFamily: theme.fonts.uniformMedium,
            fontWeight: theme.fontWeights.medium
          }
        },
        '&.heading__six': {
          fontFamily: theme.fonts.uniformMedium,
          fontWeight: theme.fontWeights.medium,
          fontSize: theme.fontSizes.h5,
          lineHeight: '140%',
          letterSpacing: theme.letterSpacings.bigCaps,
          textTransform: uppercase ? 'uppercase' : 'none',
          '&.bold': {
            fontFamily: theme.fonts.uniformMedium,
            fontWeight: theme.fontWeights.medium
          },
          '&.mobile': {
            fontSize: [theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.h5]
          }
        },
        '&.heading__seven': {
          fontFamily: theme.fonts.uniformMedium,
          fontWeight: theme.fontWeights.medium,
          fontSize: theme.fontSizes.h6,
          lineHeight: '140%',
          letterSpacing: theme.letterSpacings.bigCaps,
          textTransform: 'uppercase'
        },
        '&.sub_heading__one': {
          fontSize: theme.fontSizes.h3,
          textTransform: 'uppercase',
          '&.mobile': {
            fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3]
          }
        }
      },
      '&.display__one': {
        fontFamily: theme.fonts.uniformExtra,
        fontSize: theme.fontSizes.displayOne,
        fontWeight: theme.fontWeights.normal,
        lineHeight: '100%',
        letterSpacing: theme.letterSpacings.caps,
        textTransform: 'uppercase',
        '&.mobile': {
          fontSize: [theme.fontSizes.smallHeading, theme.fontSizes.smallHeading, theme.fontSizes.displayOneTablet, theme.fontSizes.displayOneTablet, theme.fontSizes.displayOne]
        }
      },
      '&.display__two': {
        fontFamily: theme.fonts.noe,
        fontSize: theme.fontSizes.mediumHeading,
        fontWeight: theme.fontWeights.bold,
        lineHeight: '110%',
        letterSpacing: theme.letterSpacings.mediumCaps,
        textTransform: 'none',
        '&.mobile': {
          fontSize: [theme.fontSizes.h1, theme.fontSizes.h1, theme.fontSizes.smallerHeading, theme.fontSizes.smallerHeading, theme.fontSizes.mediumHeading]
        }
      },
      '&.display__three': {
        fontFamily: theme.fonts.uniformExtra,
        fontSize: theme.fontSizes.smallHeading,
        fontWeight: theme.fontWeights.normal,
        lineHeight: '100%',
        letterSpacing: theme.letterSpacings.caps,
        textTransform: 'uppercase',
        '&.mobile': {
          fontSize: [theme.fontSizes.h1, theme.fontSizes.h1, theme.fontSizes.smallerHeading, theme.fontSizes.smallerHeading, theme.fontSizes.smallHeading]
        }
      },
      '&.display__four': {
        fontFamily: theme.fonts.uniformExtra,
        fontSize: theme.fontSizes.displayFour,
        fontWeight: theme.fontWeights.normal,
        lineHeight: '100%',
        letterSpacing: theme.letterSpacings.caps,
        textTransform: 'uppercase',
        '&.mobile': {
          fontSize: [theme.fontSizes.smallHeading, theme.fontSizes.smallHeading, theme.fontSizes.displayOneTablet, theme.fontSizes.displayOneTablet, theme.fontSizes.displayFour]
        }
      },
      '&.display__five': {
        fontFamily: theme.fonts.noe,
        fontSize: theme.fontSizes.displayFive,
        fontWeight: theme.fontWeights.bold,
        lineHeight: '110%',
        letterSpacing: theme.letterSpacings.mediumCaps,
        textTransform: capitalize ? 'capitalize' : 'none',
        '&.mobile': {
          fontSize: [theme.fontSizes.h1, theme.fontSizes.h1, theme.fontSizes.mediumHeading, theme.fontSizes.displayFive]
        }
      }
    };
  }
};